import React from 'react';
import PcLoading from '@tencent/dui/lib/components/Loading';
import MobileLoading from '@tencent/dui-mobile/lib/components/Loading';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import stylesMobile from '../../style-mobile.less';
import stylesPC from '../../style-pc.less';

const styles = browser.isMobile ? stylesMobile : stylesPC;

interface ILoadingProps {
    showLoading: boolean;
    loading: string;
}

const Loading = (props: ILoadingProps) => {
    const { showLoading, loading } = props;
    return showLoading ? <div className={styles.loadingBG}>
        <div className={styles.loadingWrapper}>
            {
                browser.isMobile
                    ? <MobileLoading /> : <PcLoading />
            }
        </div>
        <div className={styles.loadingText}>{loading}</div>
    </div> : null;
};

export default Loading;
